// extracted by mini-css-extract-plugin
export var label = "_dl-5";
export var slideContainer = "_dl-0";
export var slider = "_dl-1";
export var sliderLg = "_dl-4";
export var sliderMd = "_dl-3";
export var sliderSm = "_dl-2";